const STRIPE_SCRIPT_SRC = 'https://js.stripe.com/v3/';

let stripeLoaderPromise = null;

export const loadStripeScript = () => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Stripe can only be loaded in the browser'));
  }

  if (window.Stripe) {
    return Promise.resolve(window.Stripe);
  }

  if (stripeLoaderPromise) {
    return stripeLoaderPromise;
  }

  stripeLoaderPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(`script[src="${STRIPE_SCRIPT_SRC}"]`);

    const handleLoad = () => {
      if (window.Stripe) {
        resolve(window.Stripe);
      } else {
        reject(new Error('Stripe loaded without exposing window.Stripe'));
      }
    };

    const handleError = () => {
      reject(new Error('Failed to load Stripe.js'));
    };

    if (existingScript) {
      existingScript.addEventListener('load', handleLoad, { once: true });
      existingScript.addEventListener('error', handleError, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = STRIPE_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });
    document.head.appendChild(script);
  }).catch(error => {
    stripeLoaderPromise = null;
    throw error;
  });

  return stripeLoaderPromise;
};

export default loadStripeScript;
